// extracted by mini-css-extract-plugin
export var changeIcon = "_6x-4";
export var container = "_6x-0";
export var divider = "_6x-7";
export var externalLinkIcon = "_6x-1";
export var green = "_6x-5";
export var helpCircleIcon = "_6x-3";
export var iconButton = "_6x-2";
export var red = "_6x-6";